import { shape, string } from 'prop-types';
import React from 'react';

export default function FourZeroFour({ location }) {
  return (
    <div className="four-zero-four-layout">
      <h1 className="four-zero-four-title">404</h1>
      <h2>We're sorry. This page is lost.</h2>
      <img src="/assets/images/404.svg" alt="404" />
      <p>
        Could not find
        <span className="pct-code">{location && location.pathname}</span>
      </p>
    </div>
  );
}

FourZeroFour.propTypes = {
  location: shape({
    pathname: string,
  }),
};

FourZeroFour.defaultProps = {
  location: {
    pathname: '',
  },
};
